module.exports = __webpack_public_path__ + "static/media/devices-screens.4b6d94c1.svg";